import React from "react";
import Layout from "../common/Layout";
import InfoCard, { InfoCardData } from "../components/products/GlassInfoCard";
import productImage1 from "../assets/product/uv-print.png";
import productImage2 from "../assets/product/ceramic.png";
import productImage3 from "../assets/product/etched.png";
import productImage4 from "../assets/product/silk.png";
import productImage5 from "../assets/product/frosted.png";
import productImage6 from "../assets/product/eva.png";
import PageHeaderWithLoader from "../common/PageHeaderWithLoader";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const productCards: InfoCardData[] = [
  {
    image: productImage1,
    title: "UV Print",
    anchorId: "uv-digital-print",
    description: "Make your style statement with our cutting-edge digital prints whether it's your brand logo, artwork, or a bold design vision, we bring it to life directly on glass.",
    characteristics: [
      "Vivid, high-resolution UV printing",
      "Works on mirrors, laminated & insulated glass",
      "Long-lasting, weather-resistant color fidelity",
    ],
    applications: "Perfect for any space where glass meets creativity; whether it's feature walls, brand signage, designer partitions, or bespoke interiors.",
    direction: "imageLeft",
  },
  {
    image: productImage2,
    title: "Ceramic/ Lacquered",
    anchorId: "ceramic-lacquered-glass",
    description: "Single-color enamel or lacquer is screen-printed or sprayed on glass and fused via tempering, creating bold patterns or solid finishes.",
    characteristics: [
      "Weather-resistant ceramic prints",
      "Uniform color depth",
      "Available on annealed or tempered glass",
    ],
    applications: "Ideal for a variety of interior and exterior design purposes such as wardrobes, kitchens, doors, wall cladding, appliances etc.",
    direction: "imageRight",
  },
  {
    image: productImage3,
    title: "Etched/ Acid Washed",
    anchorId: "etched-acid-washed",
    description: "Etched or acid-washed glass provides a frosted finish with elegant texture, offering privacy without blocking natural light.",
    characteristics: [
      "Available in surface or deep etch options",
      "Smooth, matte appearance",
      "Fingerprint and glare resistant",
    ],
    applications: "Partitions, windows, signage, table tops, or wherever subtle privacy meets design.",
    direction: "imageLeft",
  },
  {
    image: productImage4,
    title: "Silk Screen",
    anchorId: "silk-screen",
    description: "A ceramic ink layer is screen-printed and then tempered into the glass, forming a permanent, high-durability design.",
    characteristics: [
      "Uniform color deposition",
      "Fade-resistant and washable",
      "Great design consistency in bulk",
    ],
    applications: "Ideal for facades, partitions, interiors, furniture, or any exterior application that calls for lasting creative designs.",
    direction: "imageRight",
  },
  {
    image: productImage5,
    title: "Frosted/ Non Reflective",
    anchorId: "frosted-non-reflective",
    description: "Glass with a diffused matte finish or anti-glare surface that controls reflection and enhances visibility in bright settings.",
    characteristics: [
      "Soft diffused light transmission",
      "Anti-glare surface for clear viewing",
      "Available in multiple translucency levels",
    ],
    applications: "Showcases, partitions, photo framing, signage, and anti-reflective screens.",
    direction: "imageLeft",
  },
  {
    image: productImage6,
    title: "EVA lamination",
    anchorId: "eva-lamination",
    description: "Glass laminated with EVA interlayer offering enhanced durability, safety, and customization.",
    characteristics: [
      "Excellent durability and bonding",
      "Allows fabric or texture inserts",
      "UV and moisture resistant",
    ],
    applications: "Interior panels, designer partitions, feature walls, stairs, railings, and architectural highlights.",
    direction: "imageRight",
  },
];

const DecorativeRange = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location.hash]);

  return (
    <Layout>
      <PageHeaderWithLoader title="Decorative Range" media={{ type: "image", src: process.env.PUBLIC_URL + "/assets/decorativeBackground.webp" }} />
      <InfoCard data={productCards} />
    </Layout>
  );
};

export default DecorativeRange; 
